/* ==========================================================================
   FreezeCap™ — Scroll-triggered reveal
   --------------------------------------------------------------------------
   IntersectionObserver one-shot per element. After an element enters the
   viewport, observer.unobserve() releases it — no ongoing CPU cost.

   Performance gates:
     • prefers-reduced-motion: skip the observer entirely; CSS handles
       the fallback (instant render at full opacity).
     • Old browsers without IntersectionObserver: instant render fallback.
     • DOMContentLoaded gate so the script runs before image/JS-heavy
       below-the-fold work.
   ========================================================================== */
(function () {
  /* Mark <html> with `fc-js` so CSS knows JS is alive — without this
     class, [data-fc-reveal] elements render at full opacity (the no-JS
     fallback in fc-animations.css). Set this BEFORE the observer is
     wired so there's no flash of revealed content. */
  document.documentElement.classList.add('fc-js');

  /* Honor user motion preferences. CSS already collapses the animation
     to instant in this case, so we have nothing to do. */
  if (window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
    return;
  }

  /* Old browser fallback — show everything immediately. */
  if (!('IntersectionObserver' in window)) {
    document.querySelectorAll('[data-fc-reveal]').forEach(function (el) {
      el.classList.add('is-visible');
    });
    return;
  }

  function init() {
    var els = document.querySelectorAll('[data-fc-reveal]');
    if (!els.length) return;

    /* Trigger timing tuned per viewport.
       Mobile fires earlier (-5 %) because touch scrolling is fast and
       the animation duration is longer (see fc-animations.css media
       query) — firing earlier gives the longer animation time to land
       before the user has scrolled past.
       Desktop fires when the element is well into the user's focal
       area (-25 % from viewport bottom + 0.15 visibility threshold)
       so the 800 ms animation runs while the user's eye is on it,
       not before. Earlier values fired too soon and the reveal
       finished before the element entered the reading zone. */
    var isMobile = window.matchMedia && window.matchMedia('(max-width: 768px)').matches;
    var rootMargin = isMobile ? '0px 0px -5% 0px' : '0px 0px -25% 0px';
    var threshold  = isMobile ? 0 : 0.15;

    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('is-visible');
          io.unobserve(entry.target);
        }
      });
    }, {
      rootMargin: rootMargin,
      threshold: threshold
    });

    els.forEach(function (el) { io.observe(el); });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
